import React from 'react';

function Map() {
  return (
    <div className="google-map">
      <iframe
        id="gmap_canvas"
        title="Kanus Digital Konum"
        src="https://maps.google.com/maps?q=Istanbul,Turkey&t=&z=11&ie=UTF8&iwloc=&output=embed"
      ></iframe>
    </div>
  );
}

export default Map;
